<template>
  <span
    class="pill"
    :class="size"
    :style="{ background: meta.bg, color: meta.fg }"
  >
    <span class="dot" :style="{ background: meta.dot }" />
    {{ meta.label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { statusMetaFor } from "./statusMeta";

const props = withDefaults(
  defineProps<{ status: string; size?: "sm" | "md" }>(),
  { size: "md" }
);

const meta = computed(() => statusMetaFor(props.status));
</script>

<style scoped>
.pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border-radius: 999px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
}
.pill.sm {
  padding: 3px 9px;
  font-size: 11px;
}
.pill.md {
  padding: 5px 11px;
  font-size: 12px;
}
.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}
</style>
